import { searchParam } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { isNewNavigationOn } from '@/app/newNavigation';
import LegacyProjectCreationPage from '@/areas/projects/LegacyProjectCreation/LegacyProjectCreationPage';
import { canCreateProject } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The page splits on user type into the customer form and `EmsRfqCreationPage`; both wear the home navbar.
export const Route = createFileRoute('/_authenticated/project_creation')({
    staticData: { access: { permissions: canCreateProject }, chrome: 'home' } satisfies PageStaticData,
    // `legacy`: the new setup's link back to this one.
    validateSearch: z.object({ legacy: searchParam.boolean('optional') }),
    // This page has no route in the new navigation, so there "New project" opens the new setup. An assembly's
    // "Create project" stays: the new setup can't take its assembly yet. So does a user without demand groups, since
    // the new setup creates them and project sourcing then shows them only with the flag.
    beforeLoad: ({ context: { session }, search, location }) => {
        if (
            isNewNavigationOn(session) &&
            session.isFeatureFlagEnabled('is_demand_groups_enabled') &&
            !search.legacy &&
            !location.state.initialValues
        ) {
            throw redirect({ to: '/projects/create', replace: true });
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LegacyProjectCreationPage />;
}
